import React from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Col,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import EmptyStateImage from './components/Image';
import LearnMoreLink from './components/LearnMoreLink';

const EmptyShareLinks = () => {
  const intl = useIntl();

  return (
    <div className="empty-state-wrapper row align-items-center justify-content-center">
      <Col lg="5" xs="12">
        <h2>{intl.formatMessage({ defaultMessage: 'Track and edit your share links' })}</h2>
        <div className="mt-4">
          {intl.formatMessage({
            defaultMessage: 'Track who’s viewing your files, edit share links on the fly, and take full control over file access and insights. Create a share link to get started!',
          })}
        </div>
        <Button tag={Link} to="/files" color="primary" className="mt-4">
          {intl.formatMessage({ defaultMessage: 'Back to files' })}
        </Button>
        <LearnMoreLink url="https://help.stockpress.co/en/articles/5937349-share-files-and-collections" />
      </Col>
      <EmptyStateImage imageUrl="/images/empty-pages/empty-share-links-page.png" height="high" />
    </div>
  );
};

export default EmptyShareLinks;
